import { FormField } from 'ui/formField';
import { InputText } from 'ui/inputs';

import { useTranslations } from '../../../hooks/useTranslations';

export type Props = {
  onChange: (name: string) => void;
  value: string;
};

export const ids = {
  inputImgName: 'cl-input-image-name',
};

export const testIds = {
  inputImgName: ids.inputImgName,
};

export const InputImageName = ({ onChange, value }: Props) => {
  const { t } = useTranslations();

  return (
    <FormField inputId={ids.inputImgName} labelText={t('input.imageName.label')}>
      <InputText
        data-test={testIds.inputImgName}
        id={ids.inputImgName}
        onChange={onChange}
        type="text"
        value={value}
      />
    </FormField>
  );
};
